import React, { useEffect, forwardRef, useImperativeHandle } from 'react';
import { TablePlus } from '../../../../../components';
import { useTable } from '../../../../../hooks/index.hook';
import {
  Columns,
  getProviderService,
} from '../../../../../services/index.service';

const ReviewProviderList = forwardRef(({ defaultKey }, ref) => {
  const extraCSVHandle = async (getData) => {
    let obj = {};
    let arr = [];
    getData &&
      getData?.rows?.length &&
      getData?.rows?.map((item) => {
        if (item?.toUser) {
          obj = {
            name: item?.toUser?.avgUserRating
              ? item?.toUser?.avgUserRating
              : '0.0',
          };
          arr.push(obj);
        }
      });
    return { averageRating: arr };
  };
  const [tableHandler, tableProps] = useTable(
    getProviderService,
    false,
    false,
    false,
    false,
    extraCSVHandle
  );

  const {
    data,
    isLoading,
    count,
    page,
    noOfPages,
    sizePerPage,
    filter,
    sortBy,
    sortType,
  } = tableProps;
  const { onFilterChange, onExport, onFilterResetChange, onTableSort } =
    tableHandler;

  const columns = Columns.reviewProviderColumn({
    onSort: onTableSort,
    onFilterChange: onFilterChange,
    filter,
    page,
    sizePerPage,
  });

  useEffect(() => {
    onFilterResetChange();
  }, [defaultKey]);

  async function fetchData() {
    try {
      let res = await onExport('', columns);
      return res;
    } catch (error) {
      console.error(error);
    }
  }
  useImperativeHandle(ref, () => ({
    fetchData,
  }));

  return (
    <>
      <TablePlus
        hasLimit
        noOfPage={noOfPages}
        sizePerPage={sizePerPage}
        page={page}
        count={count}
        tableData={data}
        tableColumns={columns}
        tableLoader={isLoading}
        onFilterResetChange={onFilterResetChange}
        showAction={false}
        selectRow="false"
        filter={filter}
        sortBy={sortBy}
        sortType={sortType}
      />
    </>
  );
});

export default ReviewProviderList;
